exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".csv-viewer{background-color:#fff;padding:20px;padding-bottom:140px}.csv-viewer table th{color:#484848}.csv-viewer table td{color:#656565}.csv-viewer table td,.csv-viewer table th{padding:5px 20px;border:1px solid #ddd}", ""]);

